/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TourPreviewRouteImport } from './routes/tour-preview'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as DemodayRouteRouteImport } from './routes/demoday/route'
import { Route as Login_formsRouteRouteImport } from './routes/_login_forms/route'
import { Route as Legal_pagesRouteRouteImport } from './routes/_legal_pages/route'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as DemodayIndexRouteImport } from './routes/demoday/index'
import { Route as OnboardingVerifyEmailSentRouteImport } from './routes/onboarding/verify-email-sent'
import { Route as OnboardingTerritoryRouteImport } from './routes/onboarding/territory'
import { Route as OnboardingTeamRouteImport } from './routes/onboarding/team'
import { Route as OnboardingPartnersRouteImport } from './routes/onboarding/partners'
import { Route as OnboardingPartnerInviteRouteImport } from './routes/onboarding/partner-invite'
import { Route as OnboardingJoinRouteImport } from './routes/onboarding/join'
import { Route as OnboardingIdealCustomerRouteImport } from './routes/onboarding/ideal-customer'
import { Route as OnboardingEmailRouteImport } from './routes/onboarding/email'
import { Route as OnboardingCompanyTerritoryRouteImport } from './routes/onboarding/company-territory'
import { Route as OnboardingClaimTerritoryRouteImport } from './routes/onboarding/claim-territory'
import { Route as OnboardingActivatedRouteImport } from './routes/onboarding/activated'
import { Route as Login_formsLoginRouteImport } from './routes/_login_forms/login'
import { Route as Login_formsCallbackRouteImport } from './routes/_login_forms/callback'
import { Route as Legal_pagesTermsRouteImport } from './routes/_legal_pages/terms'
import { Route as Legal_pagesPrivacyRouteImport } from './routes/_legal_pages/privacy'
import { Route as AuthedAdminRouteRouteImport } from './routes/_authed/admin/route'
import { Route as AuthedUserRouteRouteImport } from './routes/_authed/_user/route'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedUserIndexRouteImport } from './routes/_authed/_user/index'
import { Route as Login_formsMagic_linkMagicLinkSentRouteImport } from './routes/_login_forms/_magic_link/magic-link-sent'
import { Route as Login_formsMagic_linkMagicLinkErrorRouteImport } from './routes/_login_forms/_magic_link/magic-link-error'
import { Route as Login_formsMagic_linkMagicLinkRouteImport } from './routes/_login_forms/_magic_link/magic-link'
import { Route as Login_formsForgot_passwordUpdatePasswordRouteImport } from './routes/_login_forms/_forgot_password/update-password'
import { Route as Login_formsForgot_passwordForgotPasswordSentRouteImport } from './routes/_login_forms/_forgot_password/forgot-password-sent'
import { Route as Login_formsForgot_passwordForgotPasswordRouteImport } from './routes/_login_forms/_forgot_password/forgot-password'
import { Route as AuthedAdminQuickCreateRouteImport } from './routes/_authed/admin/quick-create'
import { Route as AuthedAdminFreshnessRouteImport } from './routes/_authed/admin/freshness'
import { Route as AuthedAdminEnrichmentStatusRouteImport } from './routes/_authed/admin/enrichment-status'
import { Route as AuthedAdminCreateRouteImport } from './routes/_authed/admin/create'
import { Route as AuthedAdminBulkUploadRouteImport } from './routes/_authed/admin/bulk-upload'
import { Route as AuthedUserTamReportRouteRouteImport } from './routes/_authed/_user/tam-report/route'
import { Route as AuthedUserSettingsRouteRouteImport } from './routes/_authed/_user/settings/route'
import { Route as AuthedUserOrganizationRouteRouteImport } from './routes/_authed/_user/organization/route'
import { Route as AuthedUserOrdersRouteRouteImport } from './routes/_authed/_user/orders/route'
import { Route as AuthedUserMarketResearchRouteRouteImport } from './routes/_authed/_user/market-research/route'
import { Route as AuthedUserInboxRouteRouteImport } from './routes/_authed/_user/inbox/route'
import { Route as AuthedUserAccountsRouteRouteImport } from './routes/_authed/_user/accounts/route'
import { Route as AuthedUserTamReportIndexRouteImport } from './routes/_authed/_user/tam-report/index'
import { Route as AuthedUserSettingsIndexRouteImport } from './routes/_authed/_user/settings/index'
import { Route as AuthedUserProductsIndexRouteImport } from './routes/_authed/_user/products/index'
import { Route as AuthedUserOrganizationIndexRouteImport } from './routes/_authed/_user/organization/index'
import { Route as AuthedUserOrdersIndexRouteImport } from './routes/_authed/_user/orders/index'
import { Route as AuthedUserMarketResearchIndexRouteImport } from './routes/_authed/_user/market-research/index'
import { Route as AuthedUserInboxIndexRouteImport } from './routes/_authed/_user/inbox/index'
import { Route as AuthedUserAgentRunsIndexRouteImport } from './routes/_authed/_user/agent-runs/index'
import { Route as AuthedUserActivityIndexRouteImport } from './routes/_authed/_user/activity/index'
import { Route as AuthedUserAccountsIndexRouteImport } from './routes/_authed/_user/accounts/index'
import { Route as AuthedUserSettingsTagsRouteImport } from './routes/_authed/_user/settings/tags'
import { Route as AuthedUserSettingsSecurityRouteImport } from './routes/_authed/_user/settings/security'
import { Route as AuthedUserSettingsOrderInboxRouteImport } from './routes/_authed/_user/settings/order-inbox'
import { Route as AuthedUserSettingsMembersRouteImport } from './routes/_authed/_user/settings/members'
import { Route as AuthedUserSettingsMeRouteImport } from './routes/_authed/_user/settings/me'
import { Route as AuthedUserSettingsIntegrationsRouteImport } from './routes/_authed/_user/settings/integrations'
import { Route as AuthedUserSettingsEmailPreferencesRouteImport } from './routes/_authed/_user/settings/email-preferences'
import { Route as AuthedUserSettingsEmailNotificationPreferencesRouteImport } from './routes/_authed/_user/settings/email-notification-preferences'
import { Route as AuthedUserOrganizationOutreachRouteImport } from './routes/_authed/_user/organization/outreach'
import { Route as AuthedUserOrganizationOrganizationProfileRouteImport } from './routes/_authed/_user/organization/organization-profile'
import { Route as AuthedUserOrganizationOfferingRouteImport } from './routes/_authed/_user/organization/offering'
import { Route as AuthedUserOrganizationCustomersRouteImport } from './routes/_authed/_user/organization/customers'
import { Route as AuthedUserOrganizationChannelPartnersRouteImport } from './routes/_authed/_user/organization/channel-partners'
import { Route as AuthedUserOrdersOrderIdRouteImport } from './routes/_authed/_user/orders/$orderId'
import { Route as AuthedUserMarketResearchMarketResearchIdRouteImport } from './routes/_authed/_user/market-research/$marketResearchId'
import { Route as AuthedUserAgentRunsRunIdRouteImport } from './routes/_authed/_user/agent-runs/$runId'
import { Route as AuthedUserAccountsAccountIdRouteRouteImport } from './routes/_authed/_user/accounts/$accountId/route'
import { Route as AuthedUserOrdersPipelineIndexRouteImport } from './routes/_authed/_user/orders/pipeline.index'
import { Route as AuthedUserAccountsAccountIdIndexRouteImport } from './routes/_authed/_user/accounts/$accountId/index'
import { Route as AuthedUserOrdersPipelineDealIdRouteImport } from './routes/_authed/_user/orders/pipeline.$dealId'
import { Route as AuthedUserAccountsAccountIdLocationsRouteImport } from './routes/_authed/_user/accounts/$accountId/locations'
import { Route as AuthedUserAccountsAccountIdOverviewIndexRouteImport } from './routes/_authed/_user/accounts/$accountId/overview/index'
import { Route as AuthedUserAccountsAccountIdHistoryIndexRouteImport } from './routes/_authed/_user/accounts/$accountId/history/index'
import { Route as AuthedUserAccountsAccountIdContactsIndexRouteImport } from './routes/_authed/_user/accounts/$accountId/contacts/index'

const TourPreviewRoute = TourPreviewRouteImport.update({
  id: '/tour-preview',
  path: '/tour-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const DemodayRouteRoute = DemodayRouteRouteImport.update({
  id: '/demoday',
  path: '/demoday',
  getParentRoute: () => rootRouteImport,
} as any)
const Login_formsRouteRoute = Login_formsRouteRouteImport.update({
  id: '/_login_forms',
  getParentRoute: () => rootRouteImport,
} as any)
const Legal_pagesRouteRoute = Legal_pagesRouteRouteImport.update({
  id: '/_legal_pages',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const DemodayIndexRoute = DemodayIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemodayRouteRoute,
} as any)
const OnboardingVerifyEmailSentRoute =
  OnboardingVerifyEmailSentRouteImport.update({
    id: '/verify-email-sent',
    path: '/verify-email-sent',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const OnboardingTerritoryRoute = OnboardingTerritoryRouteImport.update({
  id: '/territory',
  path: '/territory',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingTeamRoute = OnboardingTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingPartnersRoute = OnboardingPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingPartnerInviteRoute = OnboardingPartnerInviteRouteImport.update({
  id: '/partner-invite',
  path: '/partner-invite',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingJoinRoute = OnboardingJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingIdealCustomerRoute = OnboardingIdealCustomerRouteImport.update({
  id: '/ideal-customer',
  path: '/ideal-customer',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingEmailRoute = OnboardingEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingCompanyTerritoryRoute =
  OnboardingCompanyTerritoryRouteImport.update({
    id: '/company-territory',
    path: '/company-territory',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const OnboardingClaimTerritoryRoute =
  OnboardingClaimTerritoryRouteImport.update({
    id: '/claim-territory',
    path: '/claim-territory',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const OnboardingActivatedRoute = OnboardingActivatedRouteImport.update({
  id: '/activated',
  path: '/activated',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const Login_formsLoginRoute = Login_formsLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => Login_formsRouteRoute,
} as any)
const Login_formsCallbackRoute = Login_formsCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => Login_formsRouteRoute,
} as any)
const Legal_pagesTermsRoute = Legal_pagesTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => Legal_pagesRouteRoute,
} as any)
const Legal_pagesPrivacyRoute = Legal_pagesPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => Legal_pagesRouteRoute,
} as any)
const AuthedAdminRouteRoute = AuthedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUserRouteRoute = AuthedUserRouteRouteImport.update({
  id: '/_user',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any)
const AuthedUserIndexRoute = AuthedUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const Login_formsMagic_linkMagicLinkSentRoute =
  Login_formsMagic_linkMagicLinkSentRouteImport.update({
    id: '/_magic_link/magic-link-sent',
    path: '/magic-link-sent',
    getParentRoute: () => Login_formsRouteRoute,
  } as any)
const Login_formsMagic_linkMagicLinkErrorRoute =
  Login_formsMagic_linkMagicLinkErrorRouteImport.update({
    id: '/_magic_link/magic-link-error',
    path: '/magic-link-error',
    getParentRoute: () => Login_formsRouteRoute,
  } as any)
const Login_formsMagic_linkMagicLinkRoute =
  Login_formsMagic_linkMagicLinkRouteImport.update({
    id: '/_magic_link/magic-link',
    path: '/magic-link',
    getParentRoute: () => Login_formsRouteRoute,
  } as any)
const Login_formsForgot_passwordUpdatePasswordRoute =
  Login_formsForgot_passwordUpdatePasswordRouteImport.update({
    id: '/_forgot_password/update-password',
    path: '/update-password',
    getParentRoute: () => Login_formsRouteRoute,
  } as any)
const Login_formsForgot_passwordForgotPasswordSentRoute =
  Login_formsForgot_passwordForgotPasswordSentRouteImport.update({
    id: '/_forgot_password/forgot-password-sent',
    path: '/forgot-password-sent',
    getParentRoute: () => Login_formsRouteRoute,
  } as any)
const Login_formsForgot_passwordForgotPasswordRoute =
  Login_formsForgot_passwordForgotPasswordRouteImport.update({
    id: '/_forgot_password/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => Login_formsRouteRoute,
  } as any)
const AuthedAdminQuickCreateRoute = AuthedAdminQuickCreateRouteImport.update({
  id: '/quick-create',
  path: '/quick-create',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any)
const AuthedAdminFreshnessRoute = AuthedAdminFreshnessRouteImport.update({
  id: '/freshness',
  path: '/freshness',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any)
const AuthedAdminEnrichmentStatusRoute =
  AuthedAdminEnrichmentStatusRouteImport.update({
    id: '/enrichment-status',
    path: '/enrichment-status',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any)
const AuthedAdminCreateRoute = AuthedAdminCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any)
const AuthedAdminBulkUploadRoute = AuthedAdminBulkUploadRouteImport.update({
  id: '/bulk-upload',
  path: '/bulk-upload',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any)
const AuthedUserTamReportRouteRoute =
  AuthedUserTamReportRouteRouteImport.update({
    id: '/tam-report',
    path: '/tam-report',
    getParentRoute: () => AuthedUserRouteRoute,
  } as any)
const AuthedUserSettingsRouteRoute = AuthedUserSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const AuthedUserOrganizationRouteRoute =
  AuthedUserOrganizationRouteRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthedUserRouteRoute,
  } as any)
const AuthedUserOrdersRouteRoute = AuthedUserOrdersRouteRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const AuthedUserMarketResearchRouteRoute =
  AuthedUserMarketResearchRouteRouteImport.update({
    id: '/market-research',
    path: '/market-research',
    getParentRoute: () => AuthedUserRouteRoute,
  } as any)
const AuthedUserInboxRouteRoute = AuthedUserInboxRouteRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const AuthedUserAccountsRouteRoute = AuthedUserAccountsRouteRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const AuthedUserTamReportIndexRoute =
  AuthedUserTamReportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedUserTamReportRouteRoute,
  } as any)
const AuthedUserSettingsIndexRoute = AuthedUserSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUserSettingsRouteRoute,
} as any)
const AuthedUserProductsIndexRoute = AuthedUserProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const AuthedUserOrganizationIndexRoute =
  AuthedUserOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedUserOrganizationRouteRoute,
  } as any)
const AuthedUserOrdersIndexRoute = AuthedUserOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUserOrdersRouteRoute,
} as any)
const AuthedUserMarketResearchIndexRoute =
  AuthedUserMarketResearchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedUserMarketResearchRouteRoute,
  } as any)
const AuthedUserInboxIndexRoute = AuthedUserInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUserInboxRouteRoute,
} as any)
const AuthedUserAgentRunsIndexRoute =
  AuthedUserAgentRunsIndexRouteImport.update({
    id: '/agent-runs/',
    path: '/agent-runs/',
    getParentRoute: () => AuthedUserRouteRoute,
  } as any)
const AuthedUserActivityIndexRoute = AuthedUserActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => AuthedUserRouteRoute,
} as any)
const AuthedUserAccountsIndexRoute = AuthedUserAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUserAccountsRouteRoute,
} as any)
const AuthedUserSettingsTagsRoute = AuthedUserSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthedUserSettingsRouteRoute,
} as any)
const AuthedUserSettingsSecurityRoute =
  AuthedUserSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthedUserSettingsRouteRoute,
  } as any)
const AuthedUserSettingsOrderInboxRoute =
  AuthedUserSettingsOrderInboxRouteImport.update({
    id: '/order-inbox',
    path: '/order-inbox',
    getParentRoute: () => AuthedUserSettingsRouteRoute,
  } as any)
const AuthedUserSettingsMembersRoute =
  AuthedUserSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthedUserSettingsRouteRoute,
  } as any)
const AuthedUserSettingsMeRoute = AuthedUserSettingsMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AuthedUserSettingsRouteRoute,
} as any)
const AuthedUserSettingsIntegrationsRoute =
  AuthedUserSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthedUserSettingsRouteRoute,
  } as any)
const AuthedUserSettingsEmailPreferencesRoute =
  AuthedUserSettingsEmailPreferencesRouteImport.update({
    id: '/email-preferences',
    path: '/email-preferences',
    getParentRoute: () => AuthedUserSettingsRouteRoute,
  } as any)
const AuthedUserSettingsEmailNotificationPreferencesRoute =
  AuthedUserSettingsEmailNotificationPreferencesRouteImport.update({
    id: '/email-notification-preferences',
    path: '/email-notification-preferences',
    getParentRoute: () => AuthedUserSettingsRouteRoute,
  } as any)
const AuthedUserOrganizationOutreachRoute =
  AuthedUserOrganizationOutreachRouteImport.update({
    id: '/outreach',
    path: '/outreach',
    getParentRoute: () => AuthedUserOrganizationRouteRoute,
  } as any)
const AuthedUserOrganizationOrganizationProfileRoute =
  AuthedUserOrganizationOrganizationProfileRouteImport.update({
    id: '/organization-profile',
    path: '/organization-profile',
    getParentRoute: () => AuthedUserOrganizationRouteRoute,
  } as any)
const AuthedUserOrganizationOfferingRoute =
  AuthedUserOrganizationOfferingRouteImport.update({
    id: '/offering',
    path: '/offering',
    getParentRoute: () => AuthedUserOrganizationRouteRoute,
  } as any)
const AuthedUserOrganizationCustomersRoute =
  AuthedUserOrganizationCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthedUserOrganizationRouteRoute,
  } as any)
const AuthedUserOrganizationChannelPartnersRoute =
  AuthedUserOrganizationChannelPartnersRouteImport.update({
    id: '/channel-partners',
    path: '/channel-partners',
    getParentRoute: () => AuthedUserOrganizationRouteRoute,
  } as any)
const AuthedUserOrdersOrderIdRoute = AuthedUserOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => AuthedUserOrdersRouteRoute,
} as any)
const AuthedUserMarketResearchMarketResearchIdRoute =
  AuthedUserMarketResearchMarketResearchIdRouteImport.update({
    id: '/$marketResearchId',
    path: '/$marketResearchId',
    getParentRoute: () => AuthedUserMarketResearchRouteRoute,
  } as any)
const AuthedUserAgentRunsRunIdRoute =
  AuthedUserAgentRunsRunIdRouteImport.update({
    id: '/agent-runs/$runId',
    path: '/agent-runs/$runId',
    getParentRoute: () => AuthedUserRouteRoute,
  } as any)
const AuthedUserAccountsAccountIdRouteRoute =
  AuthedUserAccountsAccountIdRouteRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => AuthedUserAccountsRouteRoute,
  } as any)
const AuthedUserOrdersPipelineIndexRoute =
  AuthedUserOrdersPipelineIndexRouteImport.update({
    id: '/pipeline/',
    path: '/pipeline/',
    getParentRoute: () => AuthedUserOrdersRouteRoute,
  } as any)
const AuthedUserAccountsAccountIdIndexRoute =
  AuthedUserAccountsAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedUserAccountsAccountIdRouteRoute,
  } as any)
const AuthedUserOrdersPipelineDealIdRoute =
  AuthedUserOrdersPipelineDealIdRouteImport.update({
    id: '/pipeline/$dealId',
    path: '/pipeline/$dealId',
    getParentRoute: () => AuthedUserOrdersRouteRoute,
  } as any)
const AuthedUserAccountsAccountIdLocationsRoute =
  AuthedUserAccountsAccountIdLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthedUserAccountsAccountIdRouteRoute,
  } as any)
const AuthedUserAccountsAccountIdOverviewIndexRoute =
  AuthedUserAccountsAccountIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AuthedUserAccountsAccountIdRouteRoute,
  } as any)
const AuthedUserAccountsAccountIdHistoryIndexRoute =
  AuthedUserAccountsAccountIdHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => AuthedUserAccountsAccountIdRouteRoute,
  } as any)
const AuthedUserAccountsAccountIdContactsIndexRoute =
  AuthedUserAccountsAccountIdContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AuthedUserAccountsAccountIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedUserIndexRoute
  '/demoday': typeof DemodayRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/maintenance': typeof MaintenanceRoute
  '/tour-preview': typeof TourPreviewRoute
  '/admin': typeof AuthedAdminRouteRouteWithChildren
  '/privacy': typeof Legal_pagesPrivacyRoute
  '/terms': typeof Legal_pagesTermsRoute
  '/callback': typeof Login_formsCallbackRoute
  '/login': typeof Login_formsLoginRoute
  '/onboarding/activated': typeof OnboardingActivatedRoute
  '/onboarding/claim-territory': typeof OnboardingClaimTerritoryRoute
  '/onboarding/company-territory': typeof OnboardingCompanyTerritoryRoute
  '/onboarding/email': typeof OnboardingEmailRoute
  '/onboarding/ideal-customer': typeof OnboardingIdealCustomerRoute
  '/onboarding/join': typeof OnboardingJoinRoute
  '/onboarding/partner-invite': typeof OnboardingPartnerInviteRoute
  '/onboarding/partners': typeof OnboardingPartnersRoute
  '/onboarding/team': typeof OnboardingTeamRoute
  '/onboarding/territory': typeof OnboardingTerritoryRoute
  '/onboarding/verify-email-sent': typeof OnboardingVerifyEmailSentRoute
  '/demoday/': typeof DemodayIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/accounts': typeof AuthedUserAccountsRouteRouteWithChildren
  '/inbox': typeof AuthedUserInboxRouteRouteWithChildren
  '/market-research': typeof AuthedUserMarketResearchRouteRouteWithChildren
  '/orders': typeof AuthedUserOrdersRouteRouteWithChildren
  '/organization': typeof AuthedUserOrganizationRouteRouteWithChildren
  '/settings': typeof AuthedUserSettingsRouteRouteWithChildren
  '/tam-report': typeof AuthedUserTamReportRouteRouteWithChildren
  '/admin/bulk-upload': typeof AuthedAdminBulkUploadRoute
  '/admin/create': typeof AuthedAdminCreateRoute
  '/admin/enrichment-status': typeof AuthedAdminEnrichmentStatusRoute
  '/admin/freshness': typeof AuthedAdminFreshnessRoute
  '/admin/quick-create': typeof AuthedAdminQuickCreateRoute
  '/forgot-password': typeof Login_formsForgot_passwordForgotPasswordRoute
  '/forgot-password-sent': typeof Login_formsForgot_passwordForgotPasswordSentRoute
  '/update-password': typeof Login_formsForgot_passwordUpdatePasswordRoute
  '/magic-link': typeof Login_formsMagic_linkMagicLinkRoute
  '/magic-link-error': typeof Login_formsMagic_linkMagicLinkErrorRoute
  '/magic-link-sent': typeof Login_formsMagic_linkMagicLinkSentRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/accounts/$accountId': typeof AuthedUserAccountsAccountIdRouteRouteWithChildren
  '/agent-runs/$runId': typeof AuthedUserAgentRunsRunIdRoute
  '/market-research/$marketResearchId': typeof AuthedUserMarketResearchMarketResearchIdRoute
  '/orders/$orderId': typeof AuthedUserOrdersOrderIdRoute
  '/organization/channel-partners': typeof AuthedUserOrganizationChannelPartnersRoute
  '/organization/customers': typeof AuthedUserOrganizationCustomersRoute
  '/organization/offering': typeof AuthedUserOrganizationOfferingRoute
  '/organization/organization-profile': typeof AuthedUserOrganizationOrganizationProfileRoute
  '/organization/outreach': typeof AuthedUserOrganizationOutreachRoute
  '/settings/email-notification-preferences': typeof AuthedUserSettingsEmailNotificationPreferencesRoute
  '/settings/email-preferences': typeof AuthedUserSettingsEmailPreferencesRoute
  '/settings/integrations': typeof AuthedUserSettingsIntegrationsRoute
  '/settings/me': typeof AuthedUserSettingsMeRoute
  '/settings/members': typeof AuthedUserSettingsMembersRoute
  '/settings/order-inbox': typeof AuthedUserSettingsOrderInboxRoute
  '/settings/security': typeof AuthedUserSettingsSecurityRoute
  '/settings/tags': typeof AuthedUserSettingsTagsRoute
  '/accounts/': typeof AuthedUserAccountsIndexRoute
  '/activity/': typeof AuthedUserActivityIndexRoute
  '/agent-runs/': typeof AuthedUserAgentRunsIndexRoute
  '/inbox/': typeof AuthedUserInboxIndexRoute
  '/market-research/': typeof AuthedUserMarketResearchIndexRoute
  '/orders/': typeof AuthedUserOrdersIndexRoute
  '/organization/': typeof AuthedUserOrganizationIndexRoute
  '/products/': typeof AuthedUserProductsIndexRoute
  '/settings/': typeof AuthedUserSettingsIndexRoute
  '/tam-report/': typeof AuthedUserTamReportIndexRoute
  '/accounts/$accountId/locations': typeof AuthedUserAccountsAccountIdLocationsRoute
  '/orders/pipeline/$dealId': typeof AuthedUserOrdersPipelineDealIdRoute
  '/accounts/$accountId/': typeof AuthedUserAccountsAccountIdIndexRoute
  '/orders/pipeline/': typeof AuthedUserOrdersPipelineIndexRoute
  '/accounts/$accountId/contacts/': typeof AuthedUserAccountsAccountIdContactsIndexRoute
  '/accounts/$accountId/history/': typeof AuthedUserAccountsAccountIdHistoryIndexRoute
  '/accounts/$accountId/overview/': typeof AuthedUserAccountsAccountIdOverviewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedUserIndexRoute
  '/maintenance': typeof MaintenanceRoute
  '/tour-preview': typeof TourPreviewRoute
  '/privacy': typeof Legal_pagesPrivacyRoute
  '/terms': typeof Legal_pagesTermsRoute
  '/callback': typeof Login_formsCallbackRoute
  '/login': typeof Login_formsLoginRoute
  '/onboarding/activated': typeof OnboardingActivatedRoute
  '/onboarding/claim-territory': typeof OnboardingClaimTerritoryRoute
  '/onboarding/company-territory': typeof OnboardingCompanyTerritoryRoute
  '/onboarding/email': typeof OnboardingEmailRoute
  '/onboarding/ideal-customer': typeof OnboardingIdealCustomerRoute
  '/onboarding/join': typeof OnboardingJoinRoute
  '/onboarding/partner-invite': typeof OnboardingPartnerInviteRoute
  '/onboarding/partners': typeof OnboardingPartnersRoute
  '/onboarding/team': typeof OnboardingTeamRoute
  '/onboarding/territory': typeof OnboardingTerritoryRoute
  '/onboarding/verify-email-sent': typeof OnboardingVerifyEmailSentRoute
  '/demoday': typeof DemodayIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/admin/bulk-upload': typeof AuthedAdminBulkUploadRoute
  '/admin/create': typeof AuthedAdminCreateRoute
  '/admin/enrichment-status': typeof AuthedAdminEnrichmentStatusRoute
  '/admin/freshness': typeof AuthedAdminFreshnessRoute
  '/admin/quick-create': typeof AuthedAdminQuickCreateRoute
  '/forgot-password': typeof Login_formsForgot_passwordForgotPasswordRoute
  '/forgot-password-sent': typeof Login_formsForgot_passwordForgotPasswordSentRoute
  '/update-password': typeof Login_formsForgot_passwordUpdatePasswordRoute
  '/magic-link': typeof Login_formsMagic_linkMagicLinkRoute
  '/magic-link-error': typeof Login_formsMagic_linkMagicLinkErrorRoute
  '/magic-link-sent': typeof Login_formsMagic_linkMagicLinkSentRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/agent-runs/$runId': typeof AuthedUserAgentRunsRunIdRoute
  '/market-research/$marketResearchId': typeof AuthedUserMarketResearchMarketResearchIdRoute
  '/orders/$orderId': typeof AuthedUserOrdersOrderIdRoute
  '/organization/channel-partners': typeof AuthedUserOrganizationChannelPartnersRoute
  '/organization/customers': typeof AuthedUserOrganizationCustomersRoute
  '/organization/offering': typeof AuthedUserOrganizationOfferingRoute
  '/organization/organization-profile': typeof AuthedUserOrganizationOrganizationProfileRoute
  '/organization/outreach': typeof AuthedUserOrganizationOutreachRoute
  '/settings/email-notification-preferences': typeof AuthedUserSettingsEmailNotificationPreferencesRoute
  '/settings/email-preferences': typeof AuthedUserSettingsEmailPreferencesRoute
  '/settings/integrations': typeof AuthedUserSettingsIntegrationsRoute
  '/settings/me': typeof AuthedUserSettingsMeRoute
  '/settings/members': typeof AuthedUserSettingsMembersRoute
  '/settings/order-inbox': typeof AuthedUserSettingsOrderInboxRoute
  '/settings/security': typeof AuthedUserSettingsSecurityRoute
  '/settings/tags': typeof AuthedUserSettingsTagsRoute
  '/accounts': typeof AuthedUserAccountsIndexRoute
  '/activity': typeof AuthedUserActivityIndexRoute
  '/agent-runs': typeof AuthedUserAgentRunsIndexRoute
  '/inbox': typeof AuthedUserInboxIndexRoute
  '/market-research': typeof AuthedUserMarketResearchIndexRoute
  '/orders': typeof AuthedUserOrdersIndexRoute
  '/organization': typeof AuthedUserOrganizationIndexRoute
  '/products': typeof AuthedUserProductsIndexRoute
  '/settings': typeof AuthedUserSettingsIndexRoute
  '/tam-report': typeof AuthedUserTamReportIndexRoute
  '/accounts/$accountId/locations': typeof AuthedUserAccountsAccountIdLocationsRoute
  '/orders/pipeline/$dealId': typeof AuthedUserOrdersPipelineDealIdRoute
  '/accounts/$accountId': typeof AuthedUserAccountsAccountIdIndexRoute
  '/orders/pipeline': typeof AuthedUserOrdersPipelineIndexRoute
  '/accounts/$accountId/contacts': typeof AuthedUserAccountsAccountIdContactsIndexRoute
  '/accounts/$accountId/history': typeof AuthedUserAccountsAccountIdHistoryIndexRoute
  '/accounts/$accountId/overview': typeof AuthedUserAccountsAccountIdOverviewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_legal_pages': typeof Legal_pagesRouteRouteWithChildren
  '/_login_forms': typeof Login_formsRouteRouteWithChildren
  '/demoday': typeof DemodayRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/maintenance': typeof MaintenanceRoute
  '/tour-preview': typeof TourPreviewRoute
  '/_authed/_user': typeof AuthedUserRouteRouteWithChildren
  '/_authed/admin': typeof AuthedAdminRouteRouteWithChildren
  '/_legal_pages/privacy': typeof Legal_pagesPrivacyRoute
  '/_legal_pages/terms': typeof Legal_pagesTermsRoute
  '/_login_forms/callback': typeof Login_formsCallbackRoute
  '/_login_forms/login': typeof Login_formsLoginRoute
  '/onboarding/activated': typeof OnboardingActivatedRoute
  '/onboarding/claim-territory': typeof OnboardingClaimTerritoryRoute
  '/onboarding/company-territory': typeof OnboardingCompanyTerritoryRoute
  '/onboarding/email': typeof OnboardingEmailRoute
  '/onboarding/ideal-customer': typeof OnboardingIdealCustomerRoute
  '/onboarding/join': typeof OnboardingJoinRoute
  '/onboarding/partner-invite': typeof OnboardingPartnerInviteRoute
  '/onboarding/partners': typeof OnboardingPartnersRoute
  '/onboarding/team': typeof OnboardingTeamRoute
  '/onboarding/territory': typeof OnboardingTerritoryRoute
  '/onboarding/verify-email-sent': typeof OnboardingVerifyEmailSentRoute
  '/demoday/': typeof DemodayIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_authed/_user/accounts': typeof AuthedUserAccountsRouteRouteWithChildren
  '/_authed/_user/inbox': typeof AuthedUserInboxRouteRouteWithChildren
  '/_authed/_user/market-research': typeof AuthedUserMarketResearchRouteRouteWithChildren
  '/_authed/_user/orders': typeof AuthedUserOrdersRouteRouteWithChildren
  '/_authed/_user/organization': typeof AuthedUserOrganizationRouteRouteWithChildren
  '/_authed/_user/settings': typeof AuthedUserSettingsRouteRouteWithChildren
  '/_authed/_user/tam-report': typeof AuthedUserTamReportRouteRouteWithChildren
  '/_authed/admin/bulk-upload': typeof AuthedAdminBulkUploadRoute
  '/_authed/admin/create': typeof AuthedAdminCreateRoute
  '/_authed/admin/enrichment-status': typeof AuthedAdminEnrichmentStatusRoute
  '/_authed/admin/freshness': typeof AuthedAdminFreshnessRoute
  '/_authed/admin/quick-create': typeof AuthedAdminQuickCreateRoute
  '/_login_forms/_forgot_password/forgot-password': typeof Login_formsForgot_passwordForgotPasswordRoute
  '/_login_forms/_forgot_password/forgot-password-sent': typeof Login_formsForgot_passwordForgotPasswordSentRoute
  '/_login_forms/_forgot_password/update-password': typeof Login_formsForgot_passwordUpdatePasswordRoute
  '/_login_forms/_magic_link/magic-link': typeof Login_formsMagic_linkMagicLinkRoute
  '/_login_forms/_magic_link/magic-link-error': typeof Login_formsMagic_linkMagicLinkErrorRoute
  '/_login_forms/_magic_link/magic-link-sent': typeof Login_formsMagic_linkMagicLinkSentRoute
  '/_authed/_user/': typeof AuthedUserIndexRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/_user/accounts/$accountId': typeof AuthedUserAccountsAccountIdRouteRouteWithChildren
  '/_authed/_user/agent-runs/$runId': typeof AuthedUserAgentRunsRunIdRoute
  '/_authed/_user/market-research/$marketResearchId': typeof AuthedUserMarketResearchMarketResearchIdRoute
  '/_authed/_user/orders/$orderId': typeof AuthedUserOrdersOrderIdRoute
  '/_authed/_user/organization/channel-partners': typeof AuthedUserOrganizationChannelPartnersRoute
  '/_authed/_user/organization/customers': typeof AuthedUserOrganizationCustomersRoute
  '/_authed/_user/organization/offering': typeof AuthedUserOrganizationOfferingRoute
  '/_authed/_user/organization/organization-profile': typeof AuthedUserOrganizationOrganizationProfileRoute
  '/_authed/_user/organization/outreach': typeof AuthedUserOrganizationOutreachRoute
  '/_authed/_user/settings/email-notification-preferences': typeof AuthedUserSettingsEmailNotificationPreferencesRoute
  '/_authed/_user/settings/email-preferences': typeof AuthedUserSettingsEmailPreferencesRoute
  '/_authed/_user/settings/integrations': typeof AuthedUserSettingsIntegrationsRoute
  '/_authed/_user/settings/me': typeof AuthedUserSettingsMeRoute
  '/_authed/_user/settings/members': typeof AuthedUserSettingsMembersRoute
  '/_authed/_user/settings/order-inbox': typeof AuthedUserSettingsOrderInboxRoute
  '/_authed/_user/settings/security': typeof AuthedUserSettingsSecurityRoute
  '/_authed/_user/settings/tags': typeof AuthedUserSettingsTagsRoute
  '/_authed/_user/accounts/': typeof AuthedUserAccountsIndexRoute
  '/_authed/_user/activity/': typeof AuthedUserActivityIndexRoute
  '/_authed/_user/agent-runs/': typeof AuthedUserAgentRunsIndexRoute
  '/_authed/_user/inbox/': typeof AuthedUserInboxIndexRoute
  '/_authed/_user/market-research/': typeof AuthedUserMarketResearchIndexRoute
  '/_authed/_user/orders/': typeof AuthedUserOrdersIndexRoute
  '/_authed/_user/organization/': typeof AuthedUserOrganizationIndexRoute
  '/_authed/_user/products/': typeof AuthedUserProductsIndexRoute
  '/_authed/_user/settings/': typeof AuthedUserSettingsIndexRoute
  '/_authed/_user/tam-report/': typeof AuthedUserTamReportIndexRoute
  '/_authed/_user/accounts/$accountId/locations': typeof AuthedUserAccountsAccountIdLocationsRoute
  '/_authed/_user/orders/pipeline/$dealId': typeof AuthedUserOrdersPipelineDealIdRoute
  '/_authed/_user/accounts/$accountId/': typeof AuthedUserAccountsAccountIdIndexRoute
  '/_authed/_user/orders/pipeline/': typeof AuthedUserOrdersPipelineIndexRoute
  '/_authed/_user/accounts/$accountId/contacts/': typeof AuthedUserAccountsAccountIdContactsIndexRoute
  '/_authed/_user/accounts/$accountId/history/': typeof AuthedUserAccountsAccountIdHistoryIndexRoute
  '/_authed/_user/accounts/$accountId/overview/': typeof AuthedUserAccountsAccountIdOverviewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/demoday'
    | '/onboarding'
    | '/maintenance'
    | '/tour-preview'
    | '/admin'
    | '/privacy'
    | '/terms'
    | '/callback'
    | '/login'
    | '/onboarding/activated'
    | '/onboarding/claim-territory'
    | '/onboarding/company-territory'
    | '/onboarding/email'
    | '/onboarding/ideal-customer'
    | '/onboarding/join'
    | '/onboarding/partner-invite'
    | '/onboarding/partners'
    | '/onboarding/team'
    | '/onboarding/territory'
    | '/onboarding/verify-email-sent'
    | '/demoday/'
    | '/onboarding/'
    | '/accounts'
    | '/inbox'
    | '/market-research'
    | '/orders'
    | '/organization'
    | '/settings'
    | '/tam-report'
    | '/admin/bulk-upload'
    | '/admin/create'
    | '/admin/enrichment-status'
    | '/admin/freshness'
    | '/admin/quick-create'
    | '/forgot-password'
    | '/forgot-password-sent'
    | '/update-password'
    | '/magic-link'
    | '/magic-link-error'
    | '/magic-link-sent'
    | '/admin/'
    | '/accounts/$accountId'
    | '/agent-runs/$runId'
    | '/market-research/$marketResearchId'
    | '/orders/$orderId'
    | '/organization/channel-partners'
    | '/organization/customers'
    | '/organization/offering'
    | '/organization/organization-profile'
    | '/organization/outreach'
    | '/settings/email-notification-preferences'
    | '/settings/email-preferences'
    | '/settings/integrations'
    | '/settings/me'
    | '/settings/members'
    | '/settings/order-inbox'
    | '/settings/security'
    | '/settings/tags'
    | '/accounts/'
    | '/activity/'
    | '/agent-runs/'
    | '/inbox/'
    | '/market-research/'
    | '/orders/'
    | '/organization/'
    | '/products/'
    | '/settings/'
    | '/tam-report/'
    | '/accounts/$accountId/locations'
    | '/orders/pipeline/$dealId'
    | '/accounts/$accountId/'
    | '/orders/pipeline/'
    | '/accounts/$accountId/contacts/'
    | '/accounts/$accountId/history/'
    | '/accounts/$accountId/overview/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/maintenance'
    | '/tour-preview'
    | '/privacy'
    | '/terms'
    | '/callback'
    | '/login'
    | '/onboarding/activated'
    | '/onboarding/claim-territory'
    | '/onboarding/company-territory'
    | '/onboarding/email'
    | '/onboarding/ideal-customer'
    | '/onboarding/join'
    | '/onboarding/partner-invite'
    | '/onboarding/partners'
    | '/onboarding/team'
    | '/onboarding/territory'
    | '/onboarding/verify-email-sent'
    | '/demoday'
    | '/onboarding'
    | '/admin/bulk-upload'
    | '/admin/create'
    | '/admin/enrichment-status'
    | '/admin/freshness'
    | '/admin/quick-create'
    | '/forgot-password'
    | '/forgot-password-sent'
    | '/update-password'
    | '/magic-link'
    | '/magic-link-error'
    | '/magic-link-sent'
    | '/admin'
    | '/agent-runs/$runId'
    | '/market-research/$marketResearchId'
    | '/orders/$orderId'
    | '/organization/channel-partners'
    | '/organization/customers'
    | '/organization/offering'
    | '/organization/organization-profile'
    | '/organization/outreach'
    | '/settings/email-notification-preferences'
    | '/settings/email-preferences'
    | '/settings/integrations'
    | '/settings/me'
    | '/settings/members'
    | '/settings/order-inbox'
    | '/settings/security'
    | '/settings/tags'
    | '/accounts'
    | '/activity'
    | '/agent-runs'
    | '/inbox'
    | '/market-research'
    | '/orders'
    | '/organization'
    | '/products'
    | '/settings'
    | '/tam-report'
    | '/accounts/$accountId/locations'
    | '/orders/pipeline/$dealId'
    | '/accounts/$accountId'
    | '/orders/pipeline'
    | '/accounts/$accountId/contacts'
    | '/accounts/$accountId/history'
    | '/accounts/$accountId/overview'
  id:
    | '__root__'
    | '/_legal_pages'
    | '/_login_forms'
    | '/demoday'
    | '/onboarding'
    | '/_authed'
    | '/maintenance'
    | '/tour-preview'
    | '/_authed/_user'
    | '/_authed/admin'
    | '/_legal_pages/privacy'
    | '/_legal_pages/terms'
    | '/_login_forms/callback'
    | '/_login_forms/login'
    | '/onboarding/activated'
    | '/onboarding/claim-territory'
    | '/onboarding/company-territory'
    | '/onboarding/email'
    | '/onboarding/ideal-customer'
    | '/onboarding/join'
    | '/onboarding/partner-invite'
    | '/onboarding/partners'
    | '/onboarding/team'
    | '/onboarding/territory'
    | '/onboarding/verify-email-sent'
    | '/demoday/'
    | '/onboarding/'
    | '/_authed/_user/accounts'
    | '/_authed/_user/inbox'
    | '/_authed/_user/market-research'
    | '/_authed/_user/orders'
    | '/_authed/_user/organization'
    | '/_authed/_user/settings'
    | '/_authed/_user/tam-report'
    | '/_authed/admin/bulk-upload'
    | '/_authed/admin/create'
    | '/_authed/admin/enrichment-status'
    | '/_authed/admin/freshness'
    | '/_authed/admin/quick-create'
    | '/_login_forms/_forgot_password/forgot-password'
    | '/_login_forms/_forgot_password/forgot-password-sent'
    | '/_login_forms/_forgot_password/update-password'
    | '/_login_forms/_magic_link/magic-link'
    | '/_login_forms/_magic_link/magic-link-error'
    | '/_login_forms/_magic_link/magic-link-sent'
    | '/_authed/_user/'
    | '/_authed/admin/'
    | '/_authed/_user/accounts/$accountId'
    | '/_authed/_user/agent-runs/$runId'
    | '/_authed/_user/market-research/$marketResearchId'
    | '/_authed/_user/orders/$orderId'
    | '/_authed/_user/organization/channel-partners'
    | '/_authed/_user/organization/customers'
    | '/_authed/_user/organization/offering'
    | '/_authed/_user/organization/organization-profile'
    | '/_authed/_user/organization/outreach'
    | '/_authed/_user/settings/email-notification-preferences'
    | '/_authed/_user/settings/email-preferences'
    | '/_authed/_user/settings/integrations'
    | '/_authed/_user/settings/me'
    | '/_authed/_user/settings/members'
    | '/_authed/_user/settings/order-inbox'
    | '/_authed/_user/settings/security'
    | '/_authed/_user/settings/tags'
    | '/_authed/_user/accounts/'
    | '/_authed/_user/activity/'
    | '/_authed/_user/agent-runs/'
    | '/_authed/_user/inbox/'
    | '/_authed/_user/market-research/'
    | '/_authed/_user/orders/'
    | '/_authed/_user/organization/'
    | '/_authed/_user/products/'
    | '/_authed/_user/settings/'
    | '/_authed/_user/tam-report/'
    | '/_authed/_user/accounts/$accountId/locations'
    | '/_authed/_user/orders/pipeline/$dealId'
    | '/_authed/_user/accounts/$accountId/'
    | '/_authed/_user/orders/pipeline/'
    | '/_authed/_user/accounts/$accountId/contacts/'
    | '/_authed/_user/accounts/$accountId/history/'
    | '/_authed/_user/accounts/$accountId/overview/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Legal_pagesRouteRoute: typeof Legal_pagesRouteRouteWithChildren
  Login_formsRouteRoute: typeof Login_formsRouteRouteWithChildren
  DemodayRouteRoute: typeof DemodayRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  MaintenanceRoute: typeof MaintenanceRoute
  TourPreviewRoute: typeof TourPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tour-preview': {
      id: '/tour-preview'
      path: '/tour-preview'
      fullPath: '/tour-preview'
      preLoaderRoute: typeof TourPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demoday': {
      id: '/demoday'
      path: '/demoday'
      fullPath: '/demoday'
      preLoaderRoute: typeof DemodayRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login_forms': {
      id: '/_login_forms'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Login_formsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_legal_pages': {
      id: '/_legal_pages'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Legal_pagesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/demoday/': {
      id: '/demoday/'
      path: '/'
      fullPath: '/demoday/'
      preLoaderRoute: typeof DemodayIndexRouteImport
      parentRoute: typeof DemodayRouteRoute
    }
    '/onboarding/verify-email-sent': {
      id: '/onboarding/verify-email-sent'
      path: '/verify-email-sent'
      fullPath: '/onboarding/verify-email-sent'
      preLoaderRoute: typeof OnboardingVerifyEmailSentRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/territory': {
      id: '/onboarding/territory'
      path: '/territory'
      fullPath: '/onboarding/territory'
      preLoaderRoute: typeof OnboardingTerritoryRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/team': {
      id: '/onboarding/team'
      path: '/team'
      fullPath: '/onboarding/team'
      preLoaderRoute: typeof OnboardingTeamRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/partners': {
      id: '/onboarding/partners'
      path: '/partners'
      fullPath: '/onboarding/partners'
      preLoaderRoute: typeof OnboardingPartnersRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/partner-invite': {
      id: '/onboarding/partner-invite'
      path: '/partner-invite'
      fullPath: '/onboarding/partner-invite'
      preLoaderRoute: typeof OnboardingPartnerInviteRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/join': {
      id: '/onboarding/join'
      path: '/join'
      fullPath: '/onboarding/join'
      preLoaderRoute: typeof OnboardingJoinRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/ideal-customer': {
      id: '/onboarding/ideal-customer'
      path: '/ideal-customer'
      fullPath: '/onboarding/ideal-customer'
      preLoaderRoute: typeof OnboardingIdealCustomerRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/email': {
      id: '/onboarding/email'
      path: '/email'
      fullPath: '/onboarding/email'
      preLoaderRoute: typeof OnboardingEmailRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/company-territory': {
      id: '/onboarding/company-territory'
      path: '/company-territory'
      fullPath: '/onboarding/company-territory'
      preLoaderRoute: typeof OnboardingCompanyTerritoryRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/claim-territory': {
      id: '/onboarding/claim-territory'
      path: '/claim-territory'
      fullPath: '/onboarding/claim-territory'
      preLoaderRoute: typeof OnboardingClaimTerritoryRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/activated': {
      id: '/onboarding/activated'
      path: '/activated'
      fullPath: '/onboarding/activated'
      preLoaderRoute: typeof OnboardingActivatedRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/_login_forms/login': {
      id: '/_login_forms/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof Login_formsLoginRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_login_forms/callback': {
      id: '/_login_forms/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof Login_formsCallbackRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_legal_pages/terms': {
      id: '/_legal_pages/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof Legal_pagesTermsRouteImport
      parentRoute: typeof Legal_pagesRouteRoute
    }
    '/_legal_pages/privacy': {
      id: '/_legal_pages/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof Legal_pagesPrivacyRouteImport
      parentRoute: typeof Legal_pagesRouteRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_user': {
      id: '/_authed/_user'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedUserRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRouteRoute
    }
    '/_authed/_user/': {
      id: '/_authed/_user/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedUserIndexRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_login_forms/_magic_link/magic-link-sent': {
      id: '/_login_forms/_magic_link/magic-link-sent'
      path: '/magic-link-sent'
      fullPath: '/magic-link-sent'
      preLoaderRoute: typeof Login_formsMagic_linkMagicLinkSentRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_login_forms/_magic_link/magic-link-error': {
      id: '/_login_forms/_magic_link/magic-link-error'
      path: '/magic-link-error'
      fullPath: '/magic-link-error'
      preLoaderRoute: typeof Login_formsMagic_linkMagicLinkErrorRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_login_forms/_magic_link/magic-link': {
      id: '/_login_forms/_magic_link/magic-link'
      path: '/magic-link'
      fullPath: '/magic-link'
      preLoaderRoute: typeof Login_formsMagic_linkMagicLinkRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_login_forms/_forgot_password/update-password': {
      id: '/_login_forms/_forgot_password/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof Login_formsForgot_passwordUpdatePasswordRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_login_forms/_forgot_password/forgot-password-sent': {
      id: '/_login_forms/_forgot_password/forgot-password-sent'
      path: '/forgot-password-sent'
      fullPath: '/forgot-password-sent'
      preLoaderRoute: typeof Login_formsForgot_passwordForgotPasswordSentRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_login_forms/_forgot_password/forgot-password': {
      id: '/_login_forms/_forgot_password/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof Login_formsForgot_passwordForgotPasswordRouteImport
      parentRoute: typeof Login_formsRouteRoute
    }
    '/_authed/admin/quick-create': {
      id: '/_authed/admin/quick-create'
      path: '/quick-create'
      fullPath: '/admin/quick-create'
      preLoaderRoute: typeof AuthedAdminQuickCreateRouteImport
      parentRoute: typeof AuthedAdminRouteRoute
    }
    '/_authed/admin/freshness': {
      id: '/_authed/admin/freshness'
      path: '/freshness'
      fullPath: '/admin/freshness'
      preLoaderRoute: typeof AuthedAdminFreshnessRouteImport
      parentRoute: typeof AuthedAdminRouteRoute
    }
    '/_authed/admin/enrichment-status': {
      id: '/_authed/admin/enrichment-status'
      path: '/enrichment-status'
      fullPath: '/admin/enrichment-status'
      preLoaderRoute: typeof AuthedAdminEnrichmentStatusRouteImport
      parentRoute: typeof AuthedAdminRouteRoute
    }
    '/_authed/admin/create': {
      id: '/_authed/admin/create'
      path: '/create'
      fullPath: '/admin/create'
      preLoaderRoute: typeof AuthedAdminCreateRouteImport
      parentRoute: typeof AuthedAdminRouteRoute
    }
    '/_authed/admin/bulk-upload': {
      id: '/_authed/admin/bulk-upload'
      path: '/bulk-upload'
      fullPath: '/admin/bulk-upload'
      preLoaderRoute: typeof AuthedAdminBulkUploadRouteImport
      parentRoute: typeof AuthedAdminRouteRoute
    }
    '/_authed/_user/tam-report': {
      id: '/_authed/_user/tam-report'
      path: '/tam-report'
      fullPath: '/tam-report'
      preLoaderRoute: typeof AuthedUserTamReportRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/settings': {
      id: '/_authed/_user/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedUserSettingsRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/organization': {
      id: '/_authed/_user/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthedUserOrganizationRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/orders': {
      id: '/_authed/_user/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthedUserOrdersRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/market-research': {
      id: '/_authed/_user/market-research'
      path: '/market-research'
      fullPath: '/market-research'
      preLoaderRoute: typeof AuthedUserMarketResearchRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/inbox': {
      id: '/_authed/_user/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthedUserInboxRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/accounts': {
      id: '/_authed/_user/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthedUserAccountsRouteRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/tam-report/': {
      id: '/_authed/_user/tam-report/'
      path: '/'
      fullPath: '/tam-report/'
      preLoaderRoute: typeof AuthedUserTamReportIndexRouteImport
      parentRoute: typeof AuthedUserTamReportRouteRoute
    }
    '/_authed/_user/settings/': {
      id: '/_authed/_user/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedUserSettingsIndexRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/products/': {
      id: '/_authed/_user/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthedUserProductsIndexRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/organization/': {
      id: '/_authed/_user/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AuthedUserOrganizationIndexRouteImport
      parentRoute: typeof AuthedUserOrganizationRouteRoute
    }
    '/_authed/_user/orders/': {
      id: '/_authed/_user/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthedUserOrdersIndexRouteImport
      parentRoute: typeof AuthedUserOrdersRouteRoute
    }
    '/_authed/_user/market-research/': {
      id: '/_authed/_user/market-research/'
      path: '/'
      fullPath: '/market-research/'
      preLoaderRoute: typeof AuthedUserMarketResearchIndexRouteImport
      parentRoute: typeof AuthedUserMarketResearchRouteRoute
    }
    '/_authed/_user/inbox/': {
      id: '/_authed/_user/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AuthedUserInboxIndexRouteImport
      parentRoute: typeof AuthedUserInboxRouteRoute
    }
    '/_authed/_user/agent-runs/': {
      id: '/_authed/_user/agent-runs/'
      path: '/agent-runs'
      fullPath: '/agent-runs/'
      preLoaderRoute: typeof AuthedUserAgentRunsIndexRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/activity/': {
      id: '/_authed/_user/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof AuthedUserActivityIndexRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/accounts/': {
      id: '/_authed/_user/accounts/'
      path: '/'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthedUserAccountsIndexRouteImport
      parentRoute: typeof AuthedUserAccountsRouteRoute
    }
    '/_authed/_user/settings/tags': {
      id: '/_authed/_user/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthedUserSettingsTagsRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/security': {
      id: '/_authed/_user/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthedUserSettingsSecurityRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/order-inbox': {
      id: '/_authed/_user/settings/order-inbox'
      path: '/order-inbox'
      fullPath: '/settings/order-inbox'
      preLoaderRoute: typeof AuthedUserSettingsOrderInboxRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/members': {
      id: '/_authed/_user/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthedUserSettingsMembersRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/me': {
      id: '/_authed/_user/settings/me'
      path: '/me'
      fullPath: '/settings/me'
      preLoaderRoute: typeof AuthedUserSettingsMeRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/integrations': {
      id: '/_authed/_user/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthedUserSettingsIntegrationsRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/email-preferences': {
      id: '/_authed/_user/settings/email-preferences'
      path: '/email-preferences'
      fullPath: '/settings/email-preferences'
      preLoaderRoute: typeof AuthedUserSettingsEmailPreferencesRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/settings/email-notification-preferences': {
      id: '/_authed/_user/settings/email-notification-preferences'
      path: '/email-notification-preferences'
      fullPath: '/settings/email-notification-preferences'
      preLoaderRoute: typeof AuthedUserSettingsEmailNotificationPreferencesRouteImport
      parentRoute: typeof AuthedUserSettingsRouteRoute
    }
    '/_authed/_user/organization/outreach': {
      id: '/_authed/_user/organization/outreach'
      path: '/outreach'
      fullPath: '/organization/outreach'
      preLoaderRoute: typeof AuthedUserOrganizationOutreachRouteImport
      parentRoute: typeof AuthedUserOrganizationRouteRoute
    }
    '/_authed/_user/organization/organization-profile': {
      id: '/_authed/_user/organization/organization-profile'
      path: '/organization-profile'
      fullPath: '/organization/organization-profile'
      preLoaderRoute: typeof AuthedUserOrganizationOrganizationProfileRouteImport
      parentRoute: typeof AuthedUserOrganizationRouteRoute
    }
    '/_authed/_user/organization/offering': {
      id: '/_authed/_user/organization/offering'
      path: '/offering'
      fullPath: '/organization/offering'
      preLoaderRoute: typeof AuthedUserOrganizationOfferingRouteImport
      parentRoute: typeof AuthedUserOrganizationRouteRoute
    }
    '/_authed/_user/organization/customers': {
      id: '/_authed/_user/organization/customers'
      path: '/customers'
      fullPath: '/organization/customers'
      preLoaderRoute: typeof AuthedUserOrganizationCustomersRouteImport
      parentRoute: typeof AuthedUserOrganizationRouteRoute
    }
    '/_authed/_user/organization/channel-partners': {
      id: '/_authed/_user/organization/channel-partners'
      path: '/channel-partners'
      fullPath: '/organization/channel-partners'
      preLoaderRoute: typeof AuthedUserOrganizationChannelPartnersRouteImport
      parentRoute: typeof AuthedUserOrganizationRouteRoute
    }
    '/_authed/_user/orders/$orderId': {
      id: '/_authed/_user/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthedUserOrdersOrderIdRouteImport
      parentRoute: typeof AuthedUserOrdersRouteRoute
    }
    '/_authed/_user/market-research/$marketResearchId': {
      id: '/_authed/_user/market-research/$marketResearchId'
      path: '/$marketResearchId'
      fullPath: '/market-research/$marketResearchId'
      preLoaderRoute: typeof AuthedUserMarketResearchMarketResearchIdRouteImport
      parentRoute: typeof AuthedUserMarketResearchRouteRoute
    }
    '/_authed/_user/agent-runs/$runId': {
      id: '/_authed/_user/agent-runs/$runId'
      path: '/agent-runs/$runId'
      fullPath: '/agent-runs/$runId'
      preLoaderRoute: typeof AuthedUserAgentRunsRunIdRouteImport
      parentRoute: typeof AuthedUserRouteRoute
    }
    '/_authed/_user/accounts/$accountId': {
      id: '/_authed/_user/accounts/$accountId'
      path: '/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AuthedUserAccountsAccountIdRouteRouteImport
      parentRoute: typeof AuthedUserAccountsRouteRoute
    }
    '/_authed/_user/orders/pipeline/': {
      id: '/_authed/_user/orders/pipeline/'
      path: '/pipeline'
      fullPath: '/orders/pipeline/'
      preLoaderRoute: typeof AuthedUserOrdersPipelineIndexRouteImport
      parentRoute: typeof AuthedUserOrdersRouteRoute
    }
    '/_authed/_user/accounts/$accountId/': {
      id: '/_authed/_user/accounts/$accountId/'
      path: '/'
      fullPath: '/accounts/$accountId/'
      preLoaderRoute: typeof AuthedUserAccountsAccountIdIndexRouteImport
      parentRoute: typeof AuthedUserAccountsAccountIdRouteRoute
    }
    '/_authed/_user/orders/pipeline/$dealId': {
      id: '/_authed/_user/orders/pipeline/$dealId'
      path: '/pipeline/$dealId'
      fullPath: '/orders/pipeline/$dealId'
      preLoaderRoute: typeof AuthedUserOrdersPipelineDealIdRouteImport
      parentRoute: typeof AuthedUserOrdersRouteRoute
    }
    '/_authed/_user/accounts/$accountId/locations': {
      id: '/_authed/_user/accounts/$accountId/locations'
      path: '/locations'
      fullPath: '/accounts/$accountId/locations'
      preLoaderRoute: typeof AuthedUserAccountsAccountIdLocationsRouteImport
      parentRoute: typeof AuthedUserAccountsAccountIdRouteRoute
    }
    '/_authed/_user/accounts/$accountId/overview/': {
      id: '/_authed/_user/accounts/$accountId/overview/'
      path: '/overview'
      fullPath: '/accounts/$accountId/overview/'
      preLoaderRoute: typeof AuthedUserAccountsAccountIdOverviewIndexRouteImport
      parentRoute: typeof AuthedUserAccountsAccountIdRouteRoute
    }
    '/_authed/_user/accounts/$accountId/history/': {
      id: '/_authed/_user/accounts/$accountId/history/'
      path: '/history'
      fullPath: '/accounts/$accountId/history/'
      preLoaderRoute: typeof AuthedUserAccountsAccountIdHistoryIndexRouteImport
      parentRoute: typeof AuthedUserAccountsAccountIdRouteRoute
    }
    '/_authed/_user/accounts/$accountId/contacts/': {
      id: '/_authed/_user/accounts/$accountId/contacts/'
      path: '/contacts'
      fullPath: '/accounts/$accountId/contacts/'
      preLoaderRoute: typeof AuthedUserAccountsAccountIdContactsIndexRouteImport
      parentRoute: typeof AuthedUserAccountsAccountIdRouteRoute
    }
  }
}

interface Legal_pagesRouteRouteChildren {
  Legal_pagesPrivacyRoute: typeof Legal_pagesPrivacyRoute
  Legal_pagesTermsRoute: typeof Legal_pagesTermsRoute
}

const Legal_pagesRouteRouteChildren: Legal_pagesRouteRouteChildren = {
  Legal_pagesPrivacyRoute: Legal_pagesPrivacyRoute,
  Legal_pagesTermsRoute: Legal_pagesTermsRoute,
}

const Legal_pagesRouteRouteWithChildren =
  Legal_pagesRouteRoute._addFileChildren(Legal_pagesRouteRouteChildren)

interface Login_formsRouteRouteChildren {
  Login_formsCallbackRoute: typeof Login_formsCallbackRoute
  Login_formsLoginRoute: typeof Login_formsLoginRoute
  Login_formsForgot_passwordForgotPasswordRoute: typeof Login_formsForgot_passwordForgotPasswordRoute
  Login_formsForgot_passwordForgotPasswordSentRoute: typeof Login_formsForgot_passwordForgotPasswordSentRoute
  Login_formsForgot_passwordUpdatePasswordRoute: typeof Login_formsForgot_passwordUpdatePasswordRoute
  Login_formsMagic_linkMagicLinkRoute: typeof Login_formsMagic_linkMagicLinkRoute
  Login_formsMagic_linkMagicLinkErrorRoute: typeof Login_formsMagic_linkMagicLinkErrorRoute
  Login_formsMagic_linkMagicLinkSentRoute: typeof Login_formsMagic_linkMagicLinkSentRoute
}

const Login_formsRouteRouteChildren: Login_formsRouteRouteChildren = {
  Login_formsCallbackRoute: Login_formsCallbackRoute,
  Login_formsLoginRoute: Login_formsLoginRoute,
  Login_formsForgot_passwordForgotPasswordRoute:
    Login_formsForgot_passwordForgotPasswordRoute,
  Login_formsForgot_passwordForgotPasswordSentRoute:
    Login_formsForgot_passwordForgotPasswordSentRoute,
  Login_formsForgot_passwordUpdatePasswordRoute:
    Login_formsForgot_passwordUpdatePasswordRoute,
  Login_formsMagic_linkMagicLinkRoute: Login_formsMagic_linkMagicLinkRoute,
  Login_formsMagic_linkMagicLinkErrorRoute:
    Login_formsMagic_linkMagicLinkErrorRoute,
  Login_formsMagic_linkMagicLinkSentRoute:
    Login_formsMagic_linkMagicLinkSentRoute,
}

const Login_formsRouteRouteWithChildren =
  Login_formsRouteRoute._addFileChildren(Login_formsRouteRouteChildren)

interface DemodayRouteRouteChildren {
  DemodayIndexRoute: typeof DemodayIndexRoute
}

const DemodayRouteRouteChildren: DemodayRouteRouteChildren = {
  DemodayIndexRoute: DemodayIndexRoute,
}

const DemodayRouteRouteWithChildren = DemodayRouteRoute._addFileChildren(
  DemodayRouteRouteChildren,
)

interface OnboardingRouteRouteChildren {
  OnboardingActivatedRoute: typeof OnboardingActivatedRoute
  OnboardingClaimTerritoryRoute: typeof OnboardingClaimTerritoryRoute
  OnboardingCompanyTerritoryRoute: typeof OnboardingCompanyTerritoryRoute
  OnboardingEmailRoute: typeof OnboardingEmailRoute
  OnboardingIdealCustomerRoute: typeof OnboardingIdealCustomerRoute
  OnboardingJoinRoute: typeof OnboardingJoinRoute
  OnboardingPartnerInviteRoute: typeof OnboardingPartnerInviteRoute
  OnboardingPartnersRoute: typeof OnboardingPartnersRoute
  OnboardingTeamRoute: typeof OnboardingTeamRoute
  OnboardingTerritoryRoute: typeof OnboardingTerritoryRoute
  OnboardingVerifyEmailSentRoute: typeof OnboardingVerifyEmailSentRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingActivatedRoute: OnboardingActivatedRoute,
  OnboardingClaimTerritoryRoute: OnboardingClaimTerritoryRoute,
  OnboardingCompanyTerritoryRoute: OnboardingCompanyTerritoryRoute,
  OnboardingEmailRoute: OnboardingEmailRoute,
  OnboardingIdealCustomerRoute: OnboardingIdealCustomerRoute,
  OnboardingJoinRoute: OnboardingJoinRoute,
  OnboardingPartnerInviteRoute: OnboardingPartnerInviteRoute,
  OnboardingPartnersRoute: OnboardingPartnersRoute,
  OnboardingTeamRoute: OnboardingTeamRoute,
  OnboardingTerritoryRoute: OnboardingTerritoryRoute,
  OnboardingVerifyEmailSentRoute: OnboardingVerifyEmailSentRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface AuthedUserAccountsAccountIdRouteRouteChildren {
  AuthedUserAccountsAccountIdLocationsRoute: typeof AuthedUserAccountsAccountIdLocationsRoute
  AuthedUserAccountsAccountIdIndexRoute: typeof AuthedUserAccountsAccountIdIndexRoute
  AuthedUserAccountsAccountIdContactsIndexRoute: typeof AuthedUserAccountsAccountIdContactsIndexRoute
  AuthedUserAccountsAccountIdHistoryIndexRoute: typeof AuthedUserAccountsAccountIdHistoryIndexRoute
  AuthedUserAccountsAccountIdOverviewIndexRoute: typeof AuthedUserAccountsAccountIdOverviewIndexRoute
}

const AuthedUserAccountsAccountIdRouteRouteChildren: AuthedUserAccountsAccountIdRouteRouteChildren =
  {
    AuthedUserAccountsAccountIdLocationsRoute:
      AuthedUserAccountsAccountIdLocationsRoute,
    AuthedUserAccountsAccountIdIndexRoute:
      AuthedUserAccountsAccountIdIndexRoute,
    AuthedUserAccountsAccountIdContactsIndexRoute:
      AuthedUserAccountsAccountIdContactsIndexRoute,
    AuthedUserAccountsAccountIdHistoryIndexRoute:
      AuthedUserAccountsAccountIdHistoryIndexRoute,
    AuthedUserAccountsAccountIdOverviewIndexRoute:
      AuthedUserAccountsAccountIdOverviewIndexRoute,
  }

const AuthedUserAccountsAccountIdRouteRouteWithChildren =
  AuthedUserAccountsAccountIdRouteRoute._addFileChildren(
    AuthedUserAccountsAccountIdRouteRouteChildren,
  )

interface AuthedUserAccountsRouteRouteChildren {
  AuthedUserAccountsAccountIdRouteRoute: typeof AuthedUserAccountsAccountIdRouteRouteWithChildren
  AuthedUserAccountsIndexRoute: typeof AuthedUserAccountsIndexRoute
}

const AuthedUserAccountsRouteRouteChildren: AuthedUserAccountsRouteRouteChildren =
  {
    AuthedUserAccountsAccountIdRouteRoute:
      AuthedUserAccountsAccountIdRouteRouteWithChildren,
    AuthedUserAccountsIndexRoute: AuthedUserAccountsIndexRoute,
  }

const AuthedUserAccountsRouteRouteWithChildren =
  AuthedUserAccountsRouteRoute._addFileChildren(
    AuthedUserAccountsRouteRouteChildren,
  )

interface AuthedUserInboxRouteRouteChildren {
  AuthedUserInboxIndexRoute: typeof AuthedUserInboxIndexRoute
}

const AuthedUserInboxRouteRouteChildren: AuthedUserInboxRouteRouteChildren = {
  AuthedUserInboxIndexRoute: AuthedUserInboxIndexRoute,
}

const AuthedUserInboxRouteRouteWithChildren =
  AuthedUserInboxRouteRoute._addFileChildren(AuthedUserInboxRouteRouteChildren)

interface AuthedUserMarketResearchRouteRouteChildren {
  AuthedUserMarketResearchMarketResearchIdRoute: typeof AuthedUserMarketResearchMarketResearchIdRoute
  AuthedUserMarketResearchIndexRoute: typeof AuthedUserMarketResearchIndexRoute
}

const AuthedUserMarketResearchRouteRouteChildren: AuthedUserMarketResearchRouteRouteChildren =
  {
    AuthedUserMarketResearchMarketResearchIdRoute:
      AuthedUserMarketResearchMarketResearchIdRoute,
    AuthedUserMarketResearchIndexRoute: AuthedUserMarketResearchIndexRoute,
  }

const AuthedUserMarketResearchRouteRouteWithChildren =
  AuthedUserMarketResearchRouteRoute._addFileChildren(
    AuthedUserMarketResearchRouteRouteChildren,
  )

interface AuthedUserOrdersRouteRouteChildren {
  AuthedUserOrdersOrderIdRoute: typeof AuthedUserOrdersOrderIdRoute
  AuthedUserOrdersIndexRoute: typeof AuthedUserOrdersIndexRoute
  AuthedUserOrdersPipelineDealIdRoute: typeof AuthedUserOrdersPipelineDealIdRoute
  AuthedUserOrdersPipelineIndexRoute: typeof AuthedUserOrdersPipelineIndexRoute
}

const AuthedUserOrdersRouteRouteChildren: AuthedUserOrdersRouteRouteChildren = {
  AuthedUserOrdersOrderIdRoute: AuthedUserOrdersOrderIdRoute,
  AuthedUserOrdersIndexRoute: AuthedUserOrdersIndexRoute,
  AuthedUserOrdersPipelineDealIdRoute: AuthedUserOrdersPipelineDealIdRoute,
  AuthedUserOrdersPipelineIndexRoute: AuthedUserOrdersPipelineIndexRoute,
}

const AuthedUserOrdersRouteRouteWithChildren =
  AuthedUserOrdersRouteRoute._addFileChildren(
    AuthedUserOrdersRouteRouteChildren,
  )

interface AuthedUserOrganizationRouteRouteChildren {
  AuthedUserOrganizationChannelPartnersRoute: typeof AuthedUserOrganizationChannelPartnersRoute
  AuthedUserOrganizationCustomersRoute: typeof AuthedUserOrganizationCustomersRoute
  AuthedUserOrganizationOfferingRoute: typeof AuthedUserOrganizationOfferingRoute
  AuthedUserOrganizationOrganizationProfileRoute: typeof AuthedUserOrganizationOrganizationProfileRoute
  AuthedUserOrganizationOutreachRoute: typeof AuthedUserOrganizationOutreachRoute
  AuthedUserOrganizationIndexRoute: typeof AuthedUserOrganizationIndexRoute
}

const AuthedUserOrganizationRouteRouteChildren: AuthedUserOrganizationRouteRouteChildren =
  {
    AuthedUserOrganizationChannelPartnersRoute:
      AuthedUserOrganizationChannelPartnersRoute,
    AuthedUserOrganizationCustomersRoute: AuthedUserOrganizationCustomersRoute,
    AuthedUserOrganizationOfferingRoute: AuthedUserOrganizationOfferingRoute,
    AuthedUserOrganizationOrganizationProfileRoute:
      AuthedUserOrganizationOrganizationProfileRoute,
    AuthedUserOrganizationOutreachRoute: AuthedUserOrganizationOutreachRoute,
    AuthedUserOrganizationIndexRoute: AuthedUserOrganizationIndexRoute,
  }

const AuthedUserOrganizationRouteRouteWithChildren =
  AuthedUserOrganizationRouteRoute._addFileChildren(
    AuthedUserOrganizationRouteRouteChildren,
  )

interface AuthedUserSettingsRouteRouteChildren {
  AuthedUserSettingsEmailNotificationPreferencesRoute: typeof AuthedUserSettingsEmailNotificationPreferencesRoute
  AuthedUserSettingsEmailPreferencesRoute: typeof AuthedUserSettingsEmailPreferencesRoute
  AuthedUserSettingsIntegrationsRoute: typeof AuthedUserSettingsIntegrationsRoute
  AuthedUserSettingsMeRoute: typeof AuthedUserSettingsMeRoute
  AuthedUserSettingsMembersRoute: typeof AuthedUserSettingsMembersRoute
  AuthedUserSettingsOrderInboxRoute: typeof AuthedUserSettingsOrderInboxRoute
  AuthedUserSettingsSecurityRoute: typeof AuthedUserSettingsSecurityRoute
  AuthedUserSettingsTagsRoute: typeof AuthedUserSettingsTagsRoute
  AuthedUserSettingsIndexRoute: typeof AuthedUserSettingsIndexRoute
}

const AuthedUserSettingsRouteRouteChildren: AuthedUserSettingsRouteRouteChildren =
  {
    AuthedUserSettingsEmailNotificationPreferencesRoute:
      AuthedUserSettingsEmailNotificationPreferencesRoute,
    AuthedUserSettingsEmailPreferencesRoute:
      AuthedUserSettingsEmailPreferencesRoute,
    AuthedUserSettingsIntegrationsRoute: AuthedUserSettingsIntegrationsRoute,
    AuthedUserSettingsMeRoute: AuthedUserSettingsMeRoute,
    AuthedUserSettingsMembersRoute: AuthedUserSettingsMembersRoute,
    AuthedUserSettingsOrderInboxRoute: AuthedUserSettingsOrderInboxRoute,
    AuthedUserSettingsSecurityRoute: AuthedUserSettingsSecurityRoute,
    AuthedUserSettingsTagsRoute: AuthedUserSettingsTagsRoute,
    AuthedUserSettingsIndexRoute: AuthedUserSettingsIndexRoute,
  }

const AuthedUserSettingsRouteRouteWithChildren =
  AuthedUserSettingsRouteRoute._addFileChildren(
    AuthedUserSettingsRouteRouteChildren,
  )

interface AuthedUserTamReportRouteRouteChildren {
  AuthedUserTamReportIndexRoute: typeof AuthedUserTamReportIndexRoute
}

const AuthedUserTamReportRouteRouteChildren: AuthedUserTamReportRouteRouteChildren =
  {
    AuthedUserTamReportIndexRoute: AuthedUserTamReportIndexRoute,
  }

const AuthedUserTamReportRouteRouteWithChildren =
  AuthedUserTamReportRouteRoute._addFileChildren(
    AuthedUserTamReportRouteRouteChildren,
  )

interface AuthedUserRouteRouteChildren {
  AuthedUserAccountsRouteRoute: typeof AuthedUserAccountsRouteRouteWithChildren
  AuthedUserInboxRouteRoute: typeof AuthedUserInboxRouteRouteWithChildren
  AuthedUserMarketResearchRouteRoute: typeof AuthedUserMarketResearchRouteRouteWithChildren
  AuthedUserOrdersRouteRoute: typeof AuthedUserOrdersRouteRouteWithChildren
  AuthedUserOrganizationRouteRoute: typeof AuthedUserOrganizationRouteRouteWithChildren
  AuthedUserSettingsRouteRoute: typeof AuthedUserSettingsRouteRouteWithChildren
  AuthedUserTamReportRouteRoute: typeof AuthedUserTamReportRouteRouteWithChildren
  AuthedUserIndexRoute: typeof AuthedUserIndexRoute
  AuthedUserAgentRunsRunIdRoute: typeof AuthedUserAgentRunsRunIdRoute
  AuthedUserActivityIndexRoute: typeof AuthedUserActivityIndexRoute
  AuthedUserAgentRunsIndexRoute: typeof AuthedUserAgentRunsIndexRoute
  AuthedUserProductsIndexRoute: typeof AuthedUserProductsIndexRoute
}

const AuthedUserRouteRouteChildren: AuthedUserRouteRouteChildren = {
  AuthedUserAccountsRouteRoute: AuthedUserAccountsRouteRouteWithChildren,
  AuthedUserInboxRouteRoute: AuthedUserInboxRouteRouteWithChildren,
  AuthedUserMarketResearchRouteRoute:
    AuthedUserMarketResearchRouteRouteWithChildren,
  AuthedUserOrdersRouteRoute: AuthedUserOrdersRouteRouteWithChildren,
  AuthedUserOrganizationRouteRoute:
    AuthedUserOrganizationRouteRouteWithChildren,
  AuthedUserSettingsRouteRoute: AuthedUserSettingsRouteRouteWithChildren,
  AuthedUserTamReportRouteRoute: AuthedUserTamReportRouteRouteWithChildren,
  AuthedUserIndexRoute: AuthedUserIndexRoute,
  AuthedUserAgentRunsRunIdRoute: AuthedUserAgentRunsRunIdRoute,
  AuthedUserActivityIndexRoute: AuthedUserActivityIndexRoute,
  AuthedUserAgentRunsIndexRoute: AuthedUserAgentRunsIndexRoute,
  AuthedUserProductsIndexRoute: AuthedUserProductsIndexRoute,
}

const AuthedUserRouteRouteWithChildren = AuthedUserRouteRoute._addFileChildren(
  AuthedUserRouteRouteChildren,
)

interface AuthedAdminRouteRouteChildren {
  AuthedAdminBulkUploadRoute: typeof AuthedAdminBulkUploadRoute
  AuthedAdminCreateRoute: typeof AuthedAdminCreateRoute
  AuthedAdminEnrichmentStatusRoute: typeof AuthedAdminEnrichmentStatusRoute
  AuthedAdminFreshnessRoute: typeof AuthedAdminFreshnessRoute
  AuthedAdminQuickCreateRoute: typeof AuthedAdminQuickCreateRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
}

const AuthedAdminRouteRouteChildren: AuthedAdminRouteRouteChildren = {
  AuthedAdminBulkUploadRoute: AuthedAdminBulkUploadRoute,
  AuthedAdminCreateRoute: AuthedAdminCreateRoute,
  AuthedAdminEnrichmentStatusRoute: AuthedAdminEnrichmentStatusRoute,
  AuthedAdminFreshnessRoute: AuthedAdminFreshnessRoute,
  AuthedAdminQuickCreateRoute: AuthedAdminQuickCreateRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
}

const AuthedAdminRouteRouteWithChildren =
  AuthedAdminRouteRoute._addFileChildren(AuthedAdminRouteRouteChildren)

interface AuthedRouteChildren {
  AuthedUserRouteRoute: typeof AuthedUserRouteRouteWithChildren
  AuthedAdminRouteRoute: typeof AuthedAdminRouteRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedUserRouteRoute: AuthedUserRouteRouteWithChildren,
  AuthedAdminRouteRoute: AuthedAdminRouteRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  Legal_pagesRouteRoute: Legal_pagesRouteRouteWithChildren,
  Login_formsRouteRoute: Login_formsRouteRouteWithChildren,
  DemodayRouteRoute: DemodayRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  MaintenanceRoute: MaintenanceRoute,
  TourPreviewRoute: TourPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
